import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";

function ProveedoresCreate() {
  const { user } = useContext(AuthContext);
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [name, setName] = useState("");
  const [tipo, setTipo] = useState("");
  const [text, setText] = useState(false);
  const [validaBoton, setValidaBoton] = useState(true);
  const [t, i18n] = useTranslation("global");

  const clear = () => {
    setName("");
  };

  const saveProveedores = (event) => {
    event.preventDefault();
    setValidaBoton(false);
    axios
      .post(
        URL_PROVEEDORES,
        {
          name,
          tipo,
          cargos:0,
          abonos:0,
          saldo:0
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Crear Proveedor",
            detalle: name,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        clear();
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  };

  return (
    <>
      <div className="container">
        <h3 align="center">Crea un nuevo Proveedor</h3>
        <Form onSubmit={saveProveedores}>
          <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
            <Label for="exampleEmail" className="mr-sm-2">
              Proveedor
            </Label>
            <Input
              type="text"
              value={name}
              required
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
            <Label for="exampleEmail" className="mr-sm-2">
              Tipo
            </Label>
            <Input
              type="select"
              value={tipo}
              required
              onChange={(e) => {
                setTipo(e.target.value);
              }}
            >
              <option value="Agente">Agente</option>
              <option value="Agencia">Agencia</option>
              <option value="Comisionista">Comisionista</option>
              <option value="Forwarder">Forwarder</option>
              <option value="Admin">Admin</option>
              <option value="Transportista">Transportista</option>
              <option value="Servicios">Servicios</option>
            </Input>
          </FormGroup>
          <br />
          <Row className="container">
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                {t("Guardar")}
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                {t("Guardar")}
              </Button>
            )}
            <div>
              <SweetAlert
                show={text}
                title="Creado con Exito"
                onConfirm={() => {
                  setText(false);
                }}
              />
            </div>
            <Button color="danger" href="/MenuCatalogos">
            {t("Regresar")}
            </Button>
            </Row>
        </Form>
      </div>
    </>
  );
}

export default ProveedoresCreate;
